import { withStyles } from '@material-ui/core';
import InputWithChips from './InputWithChips';
import styles from './InputWithChips.styles';

export default withStyles(styles)(InputWithChips);
